export const AM_BY_PRODUCT = 'AM_BY_PRODUCT'
